<!-- Splash while the session is being established. The page underneath is not
     created until it is ready, so neither route fires its API calls against a
     session that does not exist yet - the same gate the pre-routing shell put
     on its two views. -->
<div *ngIf="showLoader" class="loader-wrapper">
    <img src="../assets/vectors/HELPDESK LOADER.svg" alt="Loader Icon">
    <div class="progress-bar-container">
        <div class="progress-bar" [class.quick-complete]="quickComplete"></div>
    </div>
    <div class="loading-text">Help Desk</div>
</div>

<!-- Both pages render here; the table of routes is in app.routes.ts. -->
<div *ngIf="isSessionOngoing && !showLoader">
    <router-outlet></router-outlet>
</div>
